const GlobeIcon = ({ color = '#fff', width = '22', height = '22', className }) => {

    return (
        <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="8.5" stroke={color} strokeWidth="1.7" />
            <line x1="3.5" y1="12" x2="20.5" y2="12" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
            <path d="M12 3.5c2.4 2.3 3.7 5.6 3.7 8.5s-1.3 6.2-3.7 8.5c-2.4-2.3-3.7-5.6-3.7-8.5S9.6 5.8 12 3.5z" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )

};

export default GlobeIcon;
